export const SUPPORTED_UPLOAD_FORMATS_LABEL = 'Supported formats: PDF, DOC, DOCX, PPT, PPTX';

export const OFFICE_UPLOAD_ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx'];

export const OFFICE_UPLOAD_ACCEPT =
  '.pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
